import React, { useState } from 'react';
import Header from '../components/Header'; // Importa el componente Header
import { questions, personalityTypes } from '../data/questions';
import Results from './Results';
import "./styles.css";

const Questionnaire = () => {
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [scores, setScores] = useState({
    A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0, I: 0
  });
  const [showResults, setShowResults] = useState(false);

  const handleAnswer = (questionId, interpretation, e) => {
    // Restar el puntaje anterior si existe
    if (answers[questionId]) {
      const previousValue = answers[questionId].value;
      setScores(prev => ({
        ...prev,
        [previousValue]: prev[previousValue] - 1
      }));
    }
    // Agregar el nuevo puntaje
    setScores(prev => ({
      ...prev,
      [interpretation.value]: prev[interpretation.value] + 1
    }));
    // Guardar la respuesta
    setAnswers(prev => ({
      ...prev,
      [questionId]: interpretation
    }));
    // Avanzar automáticamente a la siguiente pregunta si no es la última
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
    }
  };

  const calculateResults = () => {
    if (Object.keys(answers).length !== questions.length) {
      alert('Por favor responda todas las preguntas');
      return;
    }
    setShowResults(true);
  };

  if (showResults) {
    return <Results scores={scores} maxScore={questions.length} />;
  }

  return (
    //<div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-4">
	<div className="min-h-screen bg-white py-12 px-4">
      {/* Header con el logo */}
      <Header />

      <div className="max-w-4xl mx-auto p-4">
        {/* Título principal */}
        <h1 className="text-[32px] font-serif text-[#00273C] text-center mb-8">
          Test de Eneagrama
        </h1>

        {/* Subtítulo */}
        <h2 className="font-bold text-[24px] text-[#23B3A8] text-left mb-8">
          Pregunta {currentQuestion + 1} de {questions.length}
        </h2>

        {/* Contenido de la pregunta */}
        <div className="mb-8">
          <p className="font-semibold text-lg mb-6">{questions[currentQuestion].question}</p>
          <div className="space-y-4">
            {questions[currentQuestion].interpretations.map((interpretation) => (
              <button
                key={interpretation.id}
                onClick={() => handleAnswer(questions[currentQuestion].id, interpretation)}
                className={`w-full p-4 text-left rounded-lg border-2 transition-all
                    border-gray-200 hover:border-blue-300 hover:bg-gray-50
                    ${answers[questions[currentQuestion].id]?.id === interpretation.id
                      ? 'border-blue-500 bg-blue-50'
                      : ''}`}
              >
                {interpretation.text}
              </button>
            ))}
          </div>
        </div>

        {/* Botones ANTERIOR y SIGUIENTE/FINALIZAR */}
        <div className="flex justify-between mt-8 flex-col sm:flex-row">
          <button
            onClick={handlePrevious}
            disabled={currentQuestion === 0}
            className="px-6 py-3 bg-[#E6E6E6] hover:bg-[#D1D1D1] text-[#333333] font-sans text-[16px] rounded-[25px] 
              transition-colors duration-200 ease-in-out shadow-sm"
          >
            ANTERIOR
          </button>
          {currentQuestion === questions.length - 1 ? (
            <button
              onClick={calculateResults}
              className="mt-4 sm:mt-0 px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 
                transition-colors duration-200 ease-in-out text-lg"
            >
              FINALIZAR CUESTIONARIO
            </button>
          ) : (
            <button
              onClick={() => setCurrentQuestion(prev => prev + 1)}
              className="mt-4 sm:mt-0 px-6 py-3 bg-[#E6E6E6] hover:bg-[#D1D1D1] text-[#333333] font-sans text-[16px] rounded-[25px] 
                transition-colors duration-200 ease-in-out shadow-sm"
            >
              SIGUIENTE
            </button>
          )}
        </div>

        {/* Barra de progreso */}
        <div className="mt-6 bg-gray-200 rounded-full h-2.5">
          <div
            className="bg-blue-500 h-2.5 rounded-full transition-all duration-300 ease-in-out"
            style={{ width: `${((currentQuestion + 1) / questions.length) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Questionnaire;